/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

(function () {
    "use strict";

    // This array is crucial for tracking our navigation observers. It was removed in the last change.
    let navIntersectionObservers = [];

    /**
     * Determines the effective current header height based on the state of .global_header.
     * @returns {number} The calculated height of the header.
     */
    function getEffectiveHeaderHeight() {
		const mainHeader = document.querySelector('header.main_header_container');
		if (!mainHeader) return 0;
	
		// Notification bar (try both possible class names for robustness)
		let notificationBar = mainHeader.querySelector('.cmp-flindersonline-notification');
		let notificationBarHeight = 0;
		if (notificationBar && notificationBar.offsetHeight > 0 && window.getComputedStyle(notificationBar).display !== 'none') {
			notificationBarHeight = notificationBar.offsetHeight;
		}

        const isMobile = window.innerWidth < 992;
	
		// Second line header variant
		const secondLine = mainHeader.querySelector('.head_inner_second_line');
		if (secondLine && window.getComputedStyle(secondLine).display !== 'none' && secondLine.offsetHeight > 0 && !isMobile) {
			return secondLine.offsetHeight;
		}
	
		// Global header variant
		const globalHeader = mainHeader.querySelector('.global_header');
		if (globalHeader && window.getComputedStyle(globalHeader).display !== 'none' && globalHeader.offsetHeight > 0) {
			return globalHeader.offsetHeight;
		}
	
		// Fallback to main header height
		return mainHeader.offsetHeight;
	}

    /**
     * Initialize In-Page Navigation Components
     */
    function initInPageNavigation() {
        // Find all navigation components on the page
        const inPageNavs = document.getElementsByClassName("cmp-flindersonline-navigation");
        if (inPageNavs.length === 0) return;
        
        // Set up header height observer to dynamically track changes
        setupHeaderHeightObserver();
        
        // Apply scroll margin to all elements with IDs to prepare for potential anchoring
        const elementsWithIds = document.querySelectorAll('[id]');
        for (let element of elementsWithIds) {
            applyScrollMargin(element);
        }
        
        // Initialize each navigation component
        for (let navIndex = 0; navIndex < inPageNavs.length; navIndex++) {
            const inPageNav = inPageNavs[navIndex];
            
            // First set up the anchor links
            setupAnchorLinks(inPageNav);
            
            // Then set up sticky behavior and dragging
            createStickyNav(inPageNav);
            setupDraggableNavigation(inPageNav);
        }
        
        // Set up scroll tracking
        setupScrollTracking();
        
        // Check for immediate sticky need
        checkForImmediateSticky();
        
        // Handle URL hash if present - but after a delay to ensure everything is loaded
        if (window.location.hash) {
            setTimeout(() => {
                for (let navIndex = 0; navIndex < inPageNavs.length; navIndex++) {
                    handleUrlHash(inPageNavs[navIndex]);
                }
            }, 500);
        }

        // Fix mobile dropdowns
        fixMobileDropdowns();
		manageMobileButtons();
    }
    
    /**
     * Reinitialize scroll tracking after DOM changes
     */
    function reinitializeScrollTracking() {
        // Rebuild the section map and reattach event listeners
        setupScrollTracking();
        
        // Force a check of the current scroll position
        setTimeout(() => {
            // Trigger scroll event to update active link
            window.dispatchEvent(new Event('scroll'));
        }, 100);
    }

	function isEditMode() {
		// Check for editor path
		const isEditorPath = top.location.pathname.includes('/editor.html');
		
		if (isEditorPath) {
		  return 'AUTHOR';
		}
		return 'PUBLISH';
	}

    /**
     * Fix for mobile dropdown to ensure it doesn't interfere with scroll tracking
     */
    function fixMobileDropdowns() {
        const mobileDropdowns = document.querySelectorAll('.cmp-flindersonline-navigation .mobile_dropdown');
        
        mobileDropdowns.forEach(dropdown => {
            // Clear existing event listeners to prevent duplicates
            const selection = dropdown.querySelector('.selection');
            if (!selection) return;
            
            const newSelection = selection.cloneNode(true);
            selection.parentNode.replaceChild(newSelection, selection);
            
            // Add proper event handling
            newSelection.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent event from bubbling
                dropdown.classList.toggle('expanded');
                
                if (dropdown.classList.contains('expanded')) {

                    setTimeout(() => {
                        document.addEventListener('click', function clearDropDown(e) {
                            if (!dropdown.contains(e.target)) {
                                dropdown.classList.remove('expanded');
                                document.removeEventListener('click', clearDropDown);
                            }
                        });
                        
                        // Handle scroll events properly within options
                        const optionsContainer = dropdown.querySelector('.options');
                        if (optionsContainer) {
                            // Allow natural scrolling within the options container
                            optionsContainer.addEventListener('touchstart', function(e) {
                                e.stopPropagation();
                            }, { passive: true });
                            
                            optionsContainer.addEventListener('touchmove', function(e) {
                                e.stopPropagation();
                            }, { passive: true });
                            
                            optionsContainer.addEventListener('touchend', function(e) {
                                e.stopPropagation();
                            }, { passive: true });

							optionsContainer.addEventListener('wheel', function(e) {
								e.stopPropagation();
							}, { passive: true });
                        }
                    }, 10);
                }
            });
            
            // Ensure the selection link doesn't navigate
            const selectionLink = newSelection.querySelector('.link');
            if (selectionLink) {
                selectionLink.addEventListener('click', function(e) {
                    e.preventDefault();
                    return false;
                });
            }
            
            // Get the options container
            const optionsContainer = dropdown.querySelector('.options');
            if (!optionsContainer) return;
            
            // Get the nav component
            const nav = dropdown.closest('.cmp-flindersonline-navigation');
            if (!nav) return;
            
            // Get desktop links
            const desktopLinks = nav.querySelectorAll('.links .link');
            if (!desktopLinks.length) return;
            
            // Clone desktop links to mobile options if empty
            if (optionsContainer.children.length === 0) {
                desktopLinks.forEach(link => {
                    const clonedLink = link.cloneNode(true);
                    optionsContainer.appendChild(clonedLink);
                });
            }
            
            // Add click handlers to all links in the mobile dropdown
            const mobileLinks = optionsContainer.querySelectorAll('.link');
            mobileLinks.forEach(mobileLink => {
                // Remove existing click listeners to prevent duplicates
                const newMobileLink = mobileLink.cloneNode(true);
                mobileLink.parentNode.replaceChild(newMobileLink, mobileLink);
                
                            // Add new click handler
            newMobileLink.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation(); // Prevent event from bubbling
                
                // Find the corresponding desktop link
                const matchingDesktopLink = Array.from(desktopLinks).find(dl => dl.hash === this.hash);
                
                if (matchingDesktopLink) {
                    // Trigger click on the desktop link to handle all the logic
                    matchingDesktopLink.click();
                }
                
                // Close the dropdown and restore body scrolling
                dropdown.classList.remove('expanded');
                // document.body.style.overflow = '';
                // document.body.style.position = '';
                // document.body.style.width = '';
            });
            });
        });
    }

	/**
 * Manage mobile buttons - show only first button on mobile in published mode,
 * but show all buttons in editor mode
 */
function manageMobileButtons() {
    // Define mobile breakpoint (matches Bootstrap md)
    const mobileBreakpoint = 991;
    
    try {
        // Check if we're in editor mode
        const currentMode = isEditMode();
        
        // Find all navigation components
        const navComponents = document.querySelectorAll('.cmp-flindersonline-navigation');
        
        navComponents.forEach(function(nav) {
            // Find the buttons container
            const buttonsContainer = nav.querySelector('.buttons');
            if (!buttonsContainer) return;
            
            // Store original display state to restore in editor mode if needed
            if (!buttonsContainer._originalStyles) {
                // Save original styles for restoration
                const buttons = buttonsContainer.querySelectorAll('.component_section_d1 > div, a.cta-button');
                buttonsContainer._originalStyles = {};
                
                buttons.forEach((button, index) => {
                    // Use a data attribute to store index for easier identification
                    button.setAttribute('data-button-index', index);
                    // Store original display value
                    buttonsContainer._originalStyles[index] = button.style.display;
                });
            }
            
            // Find all buttons (adjust selector based on your actual structure)
            const buttons = buttonsContainer.querySelectorAll('.component_section_d1 a, a.cta-button, .parsys > div a');
            
            // Function to update visibility based on viewport width and mode
            function updateVisibility() {
                // If in author mode, show all buttons regardless of viewport
                if (currentMode === 'AUTHOR') {
                    // Restore all buttons to visible in author mode
                    const buttonElements = buttonsContainer.querySelectorAll('[data-button-index]');
                    buttonElements.forEach(button => {
                        const index = button.getAttribute('data-button-index');
                        const originalDisplay = buttonsContainer._originalStyles[index] || '';
                        button.style.display = originalDisplay;
                    });
                    
                    // Make sure container is visible
                    buttonsContainer.style.display = '';
                    return;
                }
                
                // For published mode:
                
                // If no buttons, hide container completely to remove whitespace
                if (buttons.length === 0) {
                    buttonsContainer.style.display = 'none';
                    return;
                }
                
                // Show container if it has buttons
                buttonsContainer.style.display = '';
                
                // On mobile, hide all except first button
                if (window.innerWidth <= mobileBreakpoint) {
                    buttons.forEach((button, index) => {
                        // Get parent container of button
                        const buttonContainer = button.closest('.component_section_d1') ||
                                              button.parentElement;
                        
                        if (index === 0) {
                            // Show first button
                            if (buttonContainer) buttonContainer.style.display = '';
                            button.style.display = '';
                        } else {
                            // Hide all other buttons
                            if (buttonContainer) buttonContainer.style.display = 'none';
                            else button.style.display = 'none';
                        }
                    });
                } else {
                    // On desktop, show all buttons
                    buttons.forEach(button => {
                        const buttonContainer = button.closest('.component_section_d1') ||
                                              button.parentElement;
                        
                        if (buttonContainer) buttonContainer.style.display = '';
                        button.style.display = '';
                    });
                }
            }
            
            // Initial update
            updateVisibility();
            
            // Store the function for later cleanup/reuse
            buttonsContainer._updateVisibility = updateVisibility;
        });
    } catch (error) {
        console.error("Error in manageMobileButtons:", error);
        // In case of any error, ensure buttons are visible in editor mode
        if (isEditMode() === 'AUTHOR') {
            const buttons = document.querySelectorAll('.cmp-flindersonline-navigation .buttons *');
            buttons.forEach(button => button.style.display = '');
        }
    }
}
    
    /**
     * Check all navigation components for immediate sticky need without waiting for scroll
     */
    function checkForImmediateSticky() {
        const navComponents = document.getElementsByClassName("cmp-flindersonline-navigation");
        // Use current header height from CSS variable
        const headerHeightVar = getComputedStyle(document.documentElement)
            .getPropertyValue('--header-height').trim();



        const headerHeight = parseInt(headerHeightVar) || document.querySelector('header').offsetHeight;
        
        for (let i = 0; i < navComponents.length; i++) {
            const navComponent = navComponents[i];
            const navParent = navComponent.closest('.in-page-nav');
            
            if (navParent) {
                const navRect = navParent.getBoundingClientRect();
                
                const scrollY = window.scrollY;
                // Calculate if navigation should be sticky
                const shouldBeSticky = scrollY >= navRect.top;
                setNavStickyness(navParent, navComponent, shouldBeSticky, navRect, headerHeight);
            }
        }
    }

    /**
     * Set up a ResizeObserver to track header height changes
     * This will ensure navigation sticks correctly when any header element changes size
     */
    function setupHeaderHeightObserver() {
        const header = document.querySelector('header.main_header_container');
        if (!header) {
            console.error("Main header container not found. Sticky navigation may not work correctly.");
            return;
        }
        
        // Initialize with the correct effective height
        let currentHeaderHeight = getEffectiveHeaderHeight();
        const reciteMeHeader = document.getElementById("recite-header");
        const reciteMeHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;

        document.documentElement.style.setProperty('--header-height',  `calc( ${currentHeaderHeight}px * ( 1 / var(--recite-me-zoom) ) + ${reciteMeHeight}px )`);
        
        const reinitializeAllNavObservers = () => {
            // No need to get height or set property here, it's done by the caller
            navIntersectionObservers.forEach(obs => {
                if (obs.observer) {
                    obs.observer.disconnect();
                }
                createIntersectionObserver(obs.inPageNav, obs.inPageNavParent, currentHeaderHeight);
            });
        };

        const checkForHeightChange = () => {
            const newHeaderHeight = getEffectiveHeaderHeight();
            if (Math.abs(newHeaderHeight - currentHeaderHeight) > 2) {
                const reciteMeHeader = document.getElementById("recite-header");
                const reciteMeHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;
                currentHeaderHeight = newHeaderHeight;
                document.documentElement.style.setProperty('--header-height',  `calc( ${currentHeaderHeight}px * ( 1 / var(--recite-me-zoom) ) + ${reciteMeHeight}px )`);
                reinitializeAllNavObservers();
            }
        };

        const updateHeaderHeightOnScroll = () => {
            const newHeaderHeight = getEffectiveHeaderHeight();

            const reciteMeHeader = document.getElementById("recite-header");
            const reciteMeHeight = reciteMeHeader ? reciteMeHeader.offsetHeight : 0;
            // Just update the CSS variable on scroll for smooth positioning
            document.documentElement.style.setProperty('--header-height', `calc( ${currentHeaderHeight}px * ( 1 / var(--recite-me-zoom) ) + ${reciteMeHeight}px )`);

            // Check if we need to re-initialize observers
            if (Math.abs(newHeaderHeight - currentHeaderHeight) > 2) {
                currentHeaderHeight = newHeaderHeight;
                reinitializeAllNavObservers();
            }
        };

        // Set up universal observers that just check for height changes
        const universalObserver = new MutationObserver(checkForHeightChange);
        universalObserver.observe(header, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'height']
        });
        
        const resizeObserver = new ResizeObserver(checkForHeightChange);
        resizeObserver.observe(header);
        
        window.addEventListener('scroll', debounce(updateHeaderHeightOnScroll, 10), { passive: true });
        window.addEventListener('resize', debounce(checkForHeightChange, 100), { passive: true });
    }

    /**
     * Handle URL hash for initial page load with improved scroll calculation
     * @param {HTMLElement} inPageNav - The navigation component
     */
    function handleUrlHash(inPageNav) {
        const hash = window.location.hash;
        const matchingLink = inPageNav.querySelector(`a.link[href="${hash}"]`);
        
        if (matchingLink) {
            // Mark as selected
            selectLink(matchingLink, inPageNav);
            
            // Mark as manually selected to prevent immediate override
            matchingLink.classList.add("manually-selected");
            
            // Scroll to target with correct offset - use a longer delay 
            // to ensure everything is loaded properly
            setTimeout(() => {
                const targetId = hash.substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    // Get current header height from CSS variable
                    const headerHeightVar = getComputedStyle(document.documentElement)
                        .getPropertyValue('--header-height').trim();
                    const headerHeight = parseInt(headerHeightVar) || document.querySelector('header').offsetHeight;
                    
                    const navHeight = document.querySelector('.cmp-flindersonline-navigation') ? 
                        document.querySelector('.cmp-flindersonline-navigation').offsetHeight : 58;
                    
                    // Apply explicit scroll margin with larger offset
                    const totalOffset = headerHeight + navHeight + 50;
                    
                    targetElement.style.scrollMarginTop = `${totalOffset}px`;
                    
                    // Force position calculation to ensure accurate scrolling
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                    
                    // Use direct scrollTo with larger offset
                    window.scrollTo({
                        top: targetPosition - totalOffset,
                        behavior: 'smooth'
                    });
                }
            }, 500);  // Longer delay to ensure DOM is fully loaded
        }
    }

    /**
     * Apply scroll margin to an element with dynamic header height
     * @param {HTMLElement} element - The element to apply margin to
     */
    function applyScrollMargin(element) {
        // Get current header height from CSS variable
        const headerHeightVar = getComputedStyle(document.documentElement)
            .getPropertyValue('--header-height').trim();
        const headerHeight = parseInt(headerHeightVar) || document.querySelector('header').offsetHeight;
        
        const navHeight = document.querySelector('.cmp-flindersonline-navigation') ? 
            document.querySelector('.cmp-flindersonline-navigation').offsetHeight : 58;
        
        // Use a more generous offset to ensure section is clearly visible below the navigation
        const totalOffset = headerHeight + navHeight + 50;
        
        element.style.scrollMarginTop = `${totalOffset}px`;
    }

    /**
     * Set up anchor links to properly scroll to targets using dynamic header height
     * @param {HTMLElement} inPageNav - The navigation component
     */
    function setupAnchorLinks(inPageNav) {
        const links = inPageNav.querySelectorAll(".links .link"); // Specifically target desktop links
        
        for (let link of links) {
            if (link.hash) {
                const targetId = link.hash.substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    // Apply scroll margin top for proper scrolling
                    applyScrollMargin(targetElement);
                    
                    // Add click event handler
                    link.addEventListener('click', function(e) {
                        e.preventDefault();
                        
                        // Mark all links as unselected
                        inPageNav.querySelectorAll(".link").forEach(el => {
                            el.classList.remove("selected");
                            el.classList.remove("scrolled_to");
                            el.classList.remove("manually-selected");
                        });
                        
                        // Mark this link as selected
                        this.classList.add("selected");
                        this.classList.add("scrolled_to");
                        this.classList.add("manually-selected");
                        
                        // Update mobile dropdown
                        updateMobileDropdown(inPageNav, this);
                        
                        // Scroll to target
                        scrollToTarget(targetElement);
                        
                        // Update URL without scrolling
                        if (history.pushState) {
                            history.pushState(null, null, this.hash);
                        } else {
                            location.hash = this.hash;
                        }
                    });
                }
            }
        }
    }

    /**
     * Scroll to a target element with proper offset using dynamic header height
     * @param {HTMLElement} targetElement - The element to scroll to
     */
    function scrollToTarget(targetElement) {
        // Get current header height from CSS variable
        const headerHeightVar = getComputedStyle(document.documentElement)
            .getPropertyValue('--header-height').trim();
        const headerHeight = parseInt(headerHeightVar) || document.querySelector('header').offsetHeight;
        
        const navHeight = document.querySelector('.cmp-flindersonline-navigation') ? 
            document.querySelector('.cmp-flindersonline-navigation').offsetHeight : 58;
        const totalOffset = headerHeight + navHeight + 50; // Increased offset to ensure content is visible
        
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        
        window.scrollTo({
            top: targetPosition - totalOffset,
            behavior: 'smooth'
        });
    }

    /**
     * Sets up a sticky navigation component with dynamic header height
     * @param {HTMLElement} inPageNav - The navigation component
     */
    function createStickyNav(inPageNav) {
        // Define height defaults
        const desktopHeightValue = 58;
        const mobileHeightValue = 58;
        
        // Use dataset values if available
        const desktopHeight = inPageNav.dataset.desktopHeight || desktopHeightValue;
        const mobileHeight = inPageNav.dataset.mobileHeight || mobileHeightValue;
        
        // Create styling for this nav component
        const thisHash = inPageNav.id.replace("cmp-flindersonline-navigation", "");
        let thisStyling = document.getElementById("cmp-flindersonline-navigation_style_" + thisHash);
        
        if (!thisStyling) {
            thisStyling = document.createElement("style");
            thisStyling.id = "cmp-flindersonline-navigation_style_" + thisHash;
        }
        
        // Set styling with dynamic header height using CSS variables
        // The !important here is necessary to override other potential conflicting styles
        thisStyling.innerHTML = `
            #cmp-flindersonline-navigation${thisHash} {
                height: ${desktopHeight}px !important;
            }
            #cmp-flindersonline-navigation${thisHash}.static {
                top: var(--header-height) !important;
            }
            @media (max-width: 991px) {
                #cmp-flindersonline-navigation${thisHash} {
                    height: ${mobileHeight}px !important;
                }
            }
        `;
        
        document.head.appendChild(thisStyling);

        const inPageNavParent = inPageNav.closest('.in-page-nav');
        if (!inPageNavParent) return;
        
        // Get the initial header height
        const header = document.querySelector('header.main_header_container');
        const initialHeaderHeight = header ? header.offsetHeight : 0;

        // Create the observer for the first time
        createIntersectionObserver(inPageNav, inPageNavParent, initialHeaderHeight);
    }

    /**
     * Creates and manages the IntersectionObserver for a single nav component
     * @param {HTMLElement} inPageNav - The navigation component
     * @param {HTMLElement} inPageNavParent - The parent container to observe
     * @param {number} headerHeight - The current height of the header
     */
    function createIntersectionObserver(inPageNav, inPageNavParent, headerHeight) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const elem = entry.target;
                const navElem = elem.querySelector(".cmp-flindersonline-navigation");
                
                if (navElem) {
                    const boundingRect = entry.boundingClientRect;
                    const isSticky = !entry.isIntersecting && boundingRect.top < headerHeight;
                    setNavStickyness(elem, navElem, isSticky);
                }
            });
        }, {
            root: null,
            rootMargin: `-${headerHeight}px 0px 0px 0px`,
            threshold: [0, 0.1, 0.9, 1.0]
        });
        
        observer.observe(inPageNavParent);
        
        // Store the observer instance so we can manage it
        const existingObserverIndex = navIntersectionObservers.findIndex(o => o.inPageNav === inPageNav);
        if (existingObserverIndex > -1) {
            navIntersectionObservers[existingObserverIndex].observer = observer;
        } else {
            navIntersectionObservers.push({ inPageNav, inPageNavParent, observer });
        }

        // Perform an initial check right away
        const navParentRect = inPageNavParent.getBoundingClientRect();
        if (navParentRect.top <= headerHeight) {
            setNavStickyness(inPageNavParent, inPageNav, true);
        } else {
            setNavStickyness(inPageNavParent, inPageNav, false);
        }
    }

    /**
     * Makes the navigation component draggable and adds chevron controls
     * @param {HTMLElement} nav - The navigation component
     */
    function setupDraggableNavigation(nav) {
        const linksContainer = nav.querySelector(".links");
        const linksWrapper = nav.querySelector(".links-wrapper");
        
        if (!linksContainer || !linksWrapper) return;
        
        // Skip if already initialized
        if (nav.getAttribute('data-draggable-init') === 'true') {
            return;
        }
        
        // Get chevron buttons
        const leftChevron = linksWrapper.querySelector(".scroll.left");
        const rightChevron = linksWrapper.querySelector(".scroll.right");
        
        if (!leftChevron || !rightChevron) return;
        
        // Setup dragging variables
        let isDown = false;
        let startX;
        let scrollLeft;
        
        // Setup mouse events for dragging
        linksContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            linksContainer.classList.add('active');
            startX = e.pageX - linksWrapper.offsetLeft;
            scrollLeft = linksContainer.scrollLeft;
        });
        
        document.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - linksWrapper.offsetLeft;
            const walk = (x - startX) * 1.5;
            linksContainer.scrollLeft = scrollLeft - walk;
            checkOverflow(nav);
        });
        
        document.addEventListener('mouseup', () => {
            isDown = false;
            linksContainer.classList.remove('active');
        });
        
        linksContainer.addEventListener('mouseleave', () => {
            if (!isDown) {
                linksContainer.classList.remove('active');
            }
        });
        
        // Setup chevron clicks
        leftChevron.addEventListener('click', () => {
            linksContainer.scrollLeft -= 120;
            checkOverflow(nav);
        });
        
        rightChevron.addEventListener('click', () => {
            linksContainer.scrollLeft += 120;
            checkOverflow(nav);
        });
        
        // Add scroll event listener
        linksContainer.addEventListener('scroll', () => {
            checkOverflow(nav);
        });
        
        // Initial overflow check
        checkOverflow(nav);
        
        // Mark as initialized
        nav.setAttribute('data-draggable-init', 'true');
    }

    /**
     * Check if the links container is overflowing and show/hide chevrons
     * @param {HTMLElement} nav - The navigation component
     */
    function checkOverflow(nav) {
        const linksContainer = nav.querySelector(".links");
        if (!linksContainer) return;
        
        const isOverflowing = linksContainer.scrollWidth > linksContainer.clientWidth;
        const hasLeftScroll = linksContainer.scrollLeft > 0;
        const hasRightScroll = linksContainer.scrollLeft < (linksContainer.scrollWidth - linksContainer.clientWidth - 5);
        
        nav.classList.toggle('can_scroll_left', hasLeftScroll);
        nav.classList.toggle('can_scroll_right', hasRightScroll && isOverflowing);
    }

    /**
     * Helper function to set the stickiness of navigation with dynamic header height
     * @param {HTMLElement} element - The parent element
     * @param {HTMLElement} inPageNav - The navigation component
     * @param {boolean} isSticky - Whether the navigation should be sticky
     * @param {DOMRect} boundingRect - The bounding rectangle of the parent element
     * @param {number} headerHeight - The height of the header
     */
    function setNavStickyness(element, inPageNav, isSticky, boundingRect, headerHeight) {
        // Always set the top style to match the header height (via CSS variable)
        inPageNav.style.top = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim() || '0px';

        // Only toggle classes if the state actually changes
        const isCurrentlySticky = inPageNav.classList.contains('static');
        if (isSticky && !isCurrentlySticky) {
            element.classList.add("static");
            inPageNav.classList.add("static");
            element.style.height = inPageNav.offsetHeight + 'px';
        } else if (!isSticky && isCurrentlySticky) {
            element.classList.remove("static");
            inPageNav.classList.remove("static");
            element.style.height = '';
        }

        // Check for link overflow for chevrons
        checkOverflow(inPageNav);

        // Inside the scroll event handler or wherever you update nav stickiness:
        // const navBars = document.querySelectorAll('.cmp-flindersonline-navigation');
        // navBars.forEach(navBar => {
        //     if (window.scrollY === 0) {
        //         navBar.classList.add('no-top-transition');
        //     } else {
        //         navBar.classList.remove('no-top-transition');
        //     }
        // });
    }

	/**
	 * Scroll a link into view within its scrollable container
	 * @param {HTMLElement} link - The link to scroll into view
	 * @param {HTMLElement} navComponent - The navigation component
	 */
	function scrollLinkIntoView(link, navComponent) {
		const linksContainer = navComponent.querySelector(".links");
		if (!linksContainer || !link) return;
		
		// Get container and link dimensions
		const containerRect = linksContainer.getBoundingClientRect();
		const linkRect = link.getBoundingClientRect();
		
		// Calculate positions relative to the container
		const containerLeft = containerRect.left;
		const containerRight = containerRect.right;
		const linkLeft = linkRect.left;
		const linkRight = linkRect.right;
		
		// Define buffer space (padding around the link when it comes into view)
		const buffer = 40;
		
		// Check if link is partially or completely outside the visible area
		const isLinkOutsideLeft = linkLeft < containerLeft + buffer;
		const isLinkOutsideRight = linkRight > containerRight - buffer;
		
		if (isLinkOutsideLeft || isLinkOutsideRight) {
			// Calculate the link's position within the scrollable container
			const linkOffsetLeft = link.offsetLeft;
			const linkWidth = link.offsetWidth;
			const containerWidth = linksContainer.clientWidth;
			const scrollLeft = linksContainer.scrollLeft;
			
			let newScrollLeft;
			
			if (isLinkOutsideLeft) {
				// Link is cut off on the left side - scroll to show it with buffer
				newScrollLeft = linkOffsetLeft - buffer;
			} else if (isLinkOutsideRight) {
				// Link is cut off on the right side - scroll to show it with buffer
				newScrollLeft = linkOffsetLeft - containerWidth + linkWidth + buffer;
			}
			
			// Ensure we don't scroll beyond the boundaries
			const maxScrollLeft = linksContainer.scrollWidth - containerWidth;
			newScrollLeft = Math.max(0, Math.min(newScrollLeft, maxScrollLeft));
			
			// Smooth scroll to the calculated position
			linksContainer.scrollTo({
				left: newScrollLeft,
				behavior: 'smooth'
			});
			
			// Update overflow indicators after scrolling
			setTimeout(() => {
				checkOverflow(navComponent);
			}, 300); // Wait for smooth scroll to complete
		}
	}

	/**
	 * Select a link and update UI (ENHANCED VERSION)
	 * @param {HTMLElement} link - The link to select
	 * @param {HTMLElement} navComponent - The navigation component
	 */
	function selectLink(link, navComponent) {
		// Deselect all links in this navigation component
		navComponent.querySelectorAll(".link.selected").forEach(el => {
			if (el !== link) {
				el.classList.remove("selected");
				el.classList.remove("scrolled_to");
			}
		});
		
		// Select this link
		link.classList.add("selected");
		link.classList.add("scrolled_to");
		
		// Update mobile dropdown
		updateMobileDropdown(navComponent, link);
		
		// ENHANCEMENT: Scroll the selected link into view if it's not visible
		scrollLinkIntoView(link, navComponent);
	}

    /**
     * Update mobile dropdown selection
     * @param {HTMLElement} navComponent - The navigation component
     * @param {HTMLElement} link - The selected link
     */
    function updateMobileDropdown(navComponent, link) {
        const selectionElement = navComponent.querySelector(".selection .link");
        if (selectionElement) {
            selectionElement.href = link.href;
            selectionElement.innerText = link.innerText.replaceAll("\n", "").trim();
            
            // Close dropdown if it's open
            const mobileDropdown = selectionElement.closest('.mobile_dropdown');
            if (mobileDropdown && mobileDropdown.classList.contains("expanded")) {
                mobileDropdown.classList.remove("expanded");
            }
        }

        // Update mobile options to match selected state
        const mobileOptions = navComponent.querySelector(".mobile_dropdown .options");
        if (mobileOptions) {
            const mobileLinks = mobileOptions.querySelectorAll(".link");
            mobileLinks.forEach(mobileLink => {
                // Clear all selected states
                mobileLink.classList.remove("selected", "scrolled_to", "manually-selected");
                
                // Add selected state to matching link
                if (mobileLink.getAttribute('href') === link.getAttribute('href')) {
                    mobileLink.classList.add("selected", "scrolled_to");
                    if (link.classList.contains("manually-selected")) {
                        mobileLink.classList.add("manually-selected");
                    }
                }
            });
        }
    }

    /**
     * Set up scroll tracking to highlight the current section with dynamic header height
     */
    function setupScrollTracking() {
		// Clear any existing scroll event listeners for scroll tracking
		if (window._scrollHandlerDebounced) {
			window.removeEventListener('scroll', window._scrollHandlerDebounced);
		}
		if (window._clearManuallySelectedDebounced) {
			window.removeEventListener('scroll', window._clearManuallySelectedDebounced);
		}
		
		// Get all navigation components
		const navComponents = document.getElementsByClassName("cmp-flindersonline-navigation");
		if (navComponents.length === 0) return;
		
		// Build a map of sections and their links
		const sectionMap = [];
		
		// Collect all section elements and their links
		for (let nav of navComponents) {
			const links = nav.querySelectorAll(".links .link"); // Specifically use desktop links
			
			for (let link of links) {
				if (link.hash) {
					const targetId = link.hash.substring(1);
					const targetElement = document.getElementById(targetId);
					
					if (targetElement) {
						sectionMap.push({
							element: targetElement,
							link: link,
							navComponent: nav
						});
					}
				}
			}
		}
		
		// Store the section map size for debugging
		
		// Function to update active link based on scroll position with dynamic header height
		function updateActiveLink() {
			// Get current header height from CSS variable
			const headerHeightVar = getComputedStyle(document.documentElement)
				.getPropertyValue('--header-height').trim();
			const headerHeight = parseInt(headerHeightVar) || document.querySelector('header').offsetHeight;
			
			const navHeight = document.querySelector('.cmp-flindersonline-navigation') ? 
				document.querySelector('.cmp-flindersonline-navigation').offsetHeight : 58;
			const totalOffset = headerHeight + navHeight;
			
			// Keep track if any section is found active
			let activeSectionFound = false;
			
			// Get all navigation components to update
			const navComponents = document.getElementsByClassName("cmp-flindersonline-navigation");
			
			// Check each section's position
			for (let i = 0; i < sectionMap.length; i++) {
				const section = sectionMap[i];
				const rect = section.element.getBoundingClientRect();
				
				// Check if this section is currently visible at the top of the viewport
				if (rect.top <= totalOffset && rect.bottom > totalOffset) {
					// Only update if not manually selected
					if (!section.link.classList.contains("manually-selected")) {
						selectLink(section.link, section.navComponent);
					}
					
					activeSectionFound = true;
					break;
				}
			
				// If we're at the bottom of the page, select the last section
				if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 5 && i === sectionMap.length - 1) {
					selectLink(section.link, section.navComponent);
					activeSectionFound = true;
					break;
				}
			}
			
			// If no active section was found, check if we're between sections
			if (!activeSectionFound) {
				for (let i = 0; i < sectionMap.length; i++) {
					const section = sectionMap[i];
					const rect = section.element.getBoundingClientRect();
					
					const isNextSectionNearViewport = rect.top > totalOffset && rect.top < (window.innerHeight + totalOffset);
					
					if (isNextSectionNearViewport) {
						if (i > 0) {
							const prevRect = sectionMap[i-1].element.getBoundingClientRect();
							
							const prevSectionHeight = prevRect.height;
							const scrolledPastPrevSection = Math.max(0, totalOffset - prevRect.top);
							const percentageThroughPrevSection = scrolledPastPrevSection / prevSectionHeight;

							
							if (percentageThroughPrevSection > 1.5 && rect.top < window.innerHeight * 0.5) {
								selectLink(section.link, section.navComponent);
							} else {
								selectLink(sectionMap[i-1].link, sectionMap[i-1].navComponent);
							}
						} else {
							selectLink(section.link, section.navComponent);
						}
						break;
					} 
					else if (i > 0 && rect.top > window.innerHeight && i+1 < sectionMap.length) {
						selectLink(sectionMap[i-1].link, sectionMap[i-1].navComponent);
						break;
					}
				}
			}
		}
		
		// Separate function to clear manually-selected class when scrolling
		function clearManuallySelected() {
			// Get current header height from CSS variable
			const headerHeightVar = getComputedStyle(document.documentElement)
				.getPropertyValue('--header-height').trim();
			const headerHeight = parseInt(headerHeightVar) || document.querySelector('header').offsetHeight;
			
			const navHeight = document.querySelector('.cmp-flindersonline-navigation') ? 
				document.querySelector('.cmp-flindersonline-navigation').offsetHeight : 58;
			const totalOffset = headerHeight + navHeight;
			
			for (let section of sectionMap) {
				if (section.link.classList.contains("manually-selected")) {
					const rect = section.element.getBoundingClientRect();
					
					// If we've scrolled far away from the manually selected section, clear the manual selection
					if (rect.top < -300 || rect.bottom < totalOffset || rect.top > window.innerHeight) {
						section.link.classList.remove("manually-selected");
					}
				}
			}
			
			// Re-run the update to select the correct link after clearing manual selections
			updateActiveLink();
		}
		
		// Create debounced versions of the functions
		const scrollHandlerDebounced = debounce(updateActiveLink, 50);
		const clearManuallySelectedDebounced = debounce(clearManuallySelected, 100);
		
		// Store references to the debounced functions for cleanup
		window._scrollHandlerDebounced = scrollHandlerDebounced;
		window._clearManuallySelectedDebounced = clearManuallySelectedDebounced;
		
		// Handle scroll events to update the active link
		window.addEventListener('scroll', scrollHandlerDebounced, { passive: true });
		
		// Also clear "manually-selected" class when scrolling
		window.addEventListener('scroll', clearManuallySelectedDebounced, { passive: true });
		
		// Run once on page load
		setTimeout(updateActiveLink, 100);
	}

    /**
     * Debounce function
     * @param {Function} func - The function to debounce
     * @param {number} wait - The wait time in milliseconds
     * @return {Function} - The debounced function
     */
    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                func.apply(context, args);
            }, wait);
        };
    }
    
    // Call fixMobileDropdowns and reinitializeScrollTracking on resize
    window.addEventListener('resize', debounce(function() {
        fixMobileDropdowns();
        reinitializeScrollTracking();
		manageMobileButtons();
    }, 200));
    
    // Execute when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() {
            initInPageNavigation();
            
            // Add an extra check after a short delay to ensure stickiness
            setTimeout(checkForImmediateSticky, 100);
            
            // Re-initialize scroll tracking to ensure it works properly
            setTimeout(reinitializeScrollTracking, 500);
        });
    } else {
        // If already loaded, run immediately
        requestAnimationFrame(function() {
            initInPageNavigation();
            
            // Add an extra check after a short delay to ensure stickiness
            setTimeout(checkForImmediateSticky, 100);
            
            // Re-initialize scroll tracking to ensure it works properly
            setTimeout(reinitializeScrollTracking, 500);
        });
    }
    
    // Also handle the case where page is refreshed and already scrolled
    window.addEventListener('load', function() {
        // Force another sticky check
        setTimeout(checkForImmediateSticky, 200);
        
        // Re-initialize scroll tracking after everything is loaded
        setTimeout(function() {
            fixMobileDropdowns();
            reinitializeScrollTracking();
			manageMobileButtons();
        }, 500);
    });
})();